// Constants
export const GATEWAY_URL = process.env.REACT_APP_GATEWAY_URL;
export const PROXY_URL = process.env.REACT_APP_PROXY_URL;
